<template>
  <div class="mesin-edc-content">
    <SOSlotBase
      :container-name="'mesin-list-content'"
      :bg-grey="true"
      :is-search="search.onSearch"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Mesin EDC'"
          :type="'back'"
          @back="back"
          :show-search="true"
          @search="onOpenSearch"
          v-if="!search.onSearch"
        />
      </template>
      <template v-slot:search-bar>
        <SOSearchBar
          v-if="search.onSearch"
          :context="'Transaksi'"
          :placeholder="`Ketik minimal 2 karakter`"
          :value="search.key"
          :data-count="countDataSearch"
          :search-information="`Nama mesin EDC, Nama provider, Nama outlet, Akun settlement.`"
          :waiting="search.searching"
          @do-search="doSearch"
          @loading="onLoadingSearch"
          @close="onCloseSearch"
        />
      </template>
      <template v-slot:empty-state>
        <div>
          <SOEmptyState
            v-if="!totalMesin && !isFetching && !search.onSearch"
            :message="'Belum ada mesin yang terdaftar'"
            :subMessage="'Klik tombol + untuk menambahkan'"
          />
          <SOEmptySearchState
            v-if="
              !countDataSearch &&
              !isFetching &&
              search.onSearch &&
              search.key.length > 1
            "
            @action="resetSearchFilter"
          />
        </div>
      </template>
      <template v-slot:skeleton v-if="isFetching && !isLoadMore">
        <div class="p-x-20 p-y-16 w-limit">
          <CardSkeleton v-if="!search.onSearch" />
          <SOLoadSearch v-if="search.onSearch" />
        </div>
      </template>
      <template v-slot:content>
        <div class="p-x-20" v-if="totalMesin || !search.onSearch">
          <div>
            <div class="m-x-min bg-white p-t-8">
              <label class="m-d-0 p-x-20 f-12 f-regular f-c-midgrey">
                Nominal yang ditampilkan mungkin berbeda dengan nominal
                sebenarnya di mesin EDC.
                <span class="f-c-blue" @click="gotoSelengkapnya">
                  Pelajari selengkapnya</span
                >
              </label>
            </div>
            <div class="card_breadcrum p-t-16">
              <SOHeaderList
                :title="`${totalMesin} Mesin`"
                :action-text="`<label class='p-l-8'
                                    >•<span class='p-l-8 f-c-blue'>Ringkasan</span>
                                    <svg
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M5 7.5L10 12.5L15 7.5'
                                            stroke='#206CFF'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                        />
                                    </svg> </label
                                >`"
                @action="gotoRingkasan"
                :show-filter="true"
                @filter="togleFilter(true)"
              />
            </div>
            <div>
              <SOCardMesinEdc :search="search" />
            </div>
          </div>
          <div v-if="!search.onSearch && validateAccess('edc.create')">
            <div class="flying-button-wrapper">
              <div class="flying-inside">
                <a class="flying-button" @click="gotoAddMesin"></a>
              </div>
            </div>
          </div>
          <SOLoadMoreLoading
            :id="'load-more-mesin-edc'"
            :loading="isLoadMore"
          />
        </div>
      </template>
      <template v-slot:filter>
        <SOFilter
          v-if="onFilter"
          :filter-mesin-edc="true"
          :sorting="getSorting"
          @back="togleFilter(false)"
          @do-filter="doFilter"
          @reset-filter="resetFilter"
        />
      </template>
    </SOSlotBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";

import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";

import SOFilter from "@/so-components/global/filter/base/SOFilter";

import SOCardMesinEdc from "../components/SOCardMesinEdc.vue";
import CardSkeleton from "../components/CardSkeleton.vue";

import { moduleName } from "../store/state";
import sorting from "../static/sortOrder";

export default {
  name: "MesinList",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOSearchBar,
    SOHeaderList,
    SOLoadMoreLoading,
    SOEmptyState,
    SOEmptySearchState,
    SOFilter,
    SOCardMesinEdc,
    CardSkeleton,
    SOLoadSearch,
  },
  data() {
    return {
      search: {
        key: "",
        searching: false,
        onSearch: false,
      },
      usseInit: true,
      onFilter: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      switch (from.name) {
        case "mesin.edc.detail":
        case "mesin.edc.pilih.pembayaran.batal":
        case "mesin.edc.pilih.pembayaran":
        case "mesin.edc.add":
          break;

        default:
          vm.reload();
          break;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (from.name === "mesin.edc.list") {
      this.setLastItem();
    }
    next();
  },
  mounted() {
    this.init();
    this.scrollTo();
    this.smartTrackingView("mesin_edc");
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "response",
      isFetching: "isFetching",
      isLoadMore: "isLoadMore",
      pagination: "pagination",
      listMesinEdc: "listMesinEdc",
      dataMesinEdc: "dataMesinEdc",
      displayCard: "displayCard",
      lastItemToView: "lastItemToView",
    }),
    countDataSearch() {
      return this.listMesinEdc.length;
    },
    totalMesin() {
      return this.dataMesinEdc.total;
    },
    getSorting() {
      return sorting;
    },
  },
  methods: {
    ...mapActions({
      getDataMesin: `${moduleName}/getDataMesin`,
      resetListMesin: `${moduleName}/resetListMesin`,
      resetDataMesin: `${moduleName}/resetDataMesin`,
      resetPosted: `${moduleName}/resetPosted`,
      resetPagination: `${moduleName}/resetPagination`,
      setLastItemToView: `${moduleName}/setLastItemToView`,
    }),
    async init() {
      if (this.listMesinEdc.length === 0 && this.usseInit) {
        await this.resetDataList();

        await this.resetFilter();
        await this.resetPagination();
        await this.getDataMesin(this.search);
      }
    },
    async back() {
      await this.resetDataList();
      await this.resetPagination();
      await this.resetSearchFilter();
      await this.$router.push({ name: "dashboard" });
    },
    async reload() {
      this.usseInit = false;
      await this.resetDataList();
      if (this.listMesinEdc.length === 0) {
        await this.resetPagination();
        await this.resetSearchFilter();
        await this.getDataMesin(this.search);
      }
    },
    async resetDataList() {
      await this.resetDataMesin();
      await this.resetListMesin();
    },
    gotoSelengkapnya() {
      this.$router.push({ name: "mesin.edc.selengkapnya" });
    },
    gotoRingkasan() {
      this.$router.push({ name: "mesin.edc.ringkasan" });
      this.smartTrackingClick("ringkasan_mesin_edc");
    },
    gotoAddMesin() {
      this.resetPosted();
      this.$router.push({ name: "mesin.edc.add" });
      this.smartTrackingClick("add_mesin_edc");
    },
    toggleSearch(val) {
      this.search.onSearch = val;
    },
    togleFilter(val) {
      this.onFilter = val;
    },
    onOpenSearch() {
      this.toggleSearch(true);
      this.resetFilter();
      this.resetDataList();
    },
    async onCloseSearch() {
      await this.toggleSearch(false);
      await this.resetPagination();
      await this.resetSearchFilter();
      await this.resetDataList();
      await this.init();
    },
    async doSearch(searchKey) {
      this.search.key = searchKey;
      await this.onLoadingSearch(false);
      await this.resetDataList();
      await this.resetPagination();
      await this.getDataMesin(this.search);
    },
    async doFilter() {
      await this.resetPagination();
      await this.resetDataList();
      await this.togleFilter(false);
      await this.getDataMesin(this.search);
    },
    onLoadingSearch(value) {
      this.search.searching = value;
    },
    async resetFilter() {
      await this.$store.commit("filterGlobalModule/resetFilterItem");
      await this.$store.commit(
        "filterGlobalModule/setFilter",
        JSON.parse(this.getSorting[0].value)
      );
    },
    resetSearchFilter() {
      this.resetFilter();
      this.search.key = "";
    },
    scrollTo() {
      let el = document.getElementById(this.lastItemToView.id);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView();
          document.documentElement.scrollTop =
            document.documentElement.scrollTop - 53;
        }, 100);
      }
    },
    setLastItem() {
      let newDP = this.displayCard.sort(function (a, b) {
        if (a.yDir < b.yDir) {
          return -1;
        }
        if (a.yDir > b.yDir) {
          return 1;
        }
        return 0;
      });

      if (newDP[0]) {
        this.setLastItemToView(newDP[0]);
      }
    },
  },
};
</script>
<style scoped>
.dot {
  border: 1px;
}
</style>
